import { default as WJElement } from '../wje-element/element.js';
import RouterOutlet from './router-outlet.element.js';

export default RouterOutlet;

WJElement.define('wje-router-outlet', RouterOutlet);
